import fr from 'facet-rest';

const infoNodes = [
  {
    id: '1',
    attributes: {
      icon: 'outcomeSavings',
      label: 'Checking',
      linksWith: '5', // In this example there are 4 resources in the info column
      value: '1', // The height this will take on the chart
      semantic: 'account-name',
    },
  },
  {
    id: '2',
    attributes: {
      icon: 'outcomeSavings',
      label: 'Savings for an imaginary horse I once loved',
      linksWith: '6',
      value: '1',
      semantic: 'account-name',
    },
  },
  {
    id: '3',
    attributes: {
      icon: 'outcomeRetirement',
      label: 'Retirement',
      linksWith: '7',
      value: '1',
      semantic: 'account-name',
    },
  },
  {
    id: '4',
    attributes: {
      icon: 'outcomeRetirement',
      label: 'Rollover prior employer retirement account from Betterment',
      linksWith: '8',
      value: '1',
      semantic: 'account-name',
    },
  },
];

const amountNodes = [
  {
    id: '5',
    attributes: {
      label: '$870',
      linksWith: '9',
      value: '1',
      semantic: 'amount',
    },
  },
  {
    id: '6',
    attributes: {
      label: '$2,610',
      linksWith: '9',
      value: '1',
      semantic: 'amount',
    },
  },
  {
    id: '7',
    attributes: {
      label: '$3,480',
      linksWith: '9',
      value: '1',
      semantic: 'amount',
    },
  },
  {
    id: '8',
    attributes: {
      label: '$1,740',
      linksWith: '9',
      value: '1',
      semantic: 'amount',
    },
  },
];

const resultNodes = [
  {
    id: '9',
    attributes: {
      label: '$8,700',
      value: '0',
      semantic: 'result',
    },
  },
];

const jsonResource = {
  attributes: {
    nodes: { data: [...infoNodes, ...amountNodes, ...resultNodes] },
  },
  meta: {
    template: [
      {
        name: 'nodes',
        type: 'collection',
        prompt: 'Nodes',
        readonly: true,
      },
    ],
  },
};

export const buildTestData = () => {
  const getPathId = (links, nodeId) => {
    const prev = links.find(v => v.target === nodeId);

    if (prev) {
      return getPathId(links, prev.source);
    }

    return nodeId;
  };

  const dataResource = fr.resource(jsonResource);
  const nodeResources = dataResource.attr('nodes').resources().list();

  const links = nodeResources.filter(res => {
    return res.attr('linksWith')?.length > 0; // Is a string that has some length to it
  }).map((res) => {
    return {
      source: res.id(),
      target: res.attr('linksWith'),
      value: +res.attr('value'),
    };
  });


  return {
    nodes: nodeResources.map((res) => {
      return {
        nodeId: res.id(),
        icon: res.attr('icon'),
        label: res.attr('label'),
        value: +res.attr('value'),
        semantic: res.attr('semantic'),
      };
    }),
    links: links.map(v => ({
      ...v,
      pathId: getPathId(links, v.source),
    })),
  };
};
